'use client';

import { useSlotRecipe } from '@chakra-ui/react';

import { StickyBar, StickyBarDirection } from '@app/components/molecules/sticky-bar';
import { SwitchStickyBarProps } from '@app/components/molecules/switch-sticky-bar';
import { useSearchFilters } from '@app/hooks/useSearchFilters';
import { selectors as listingStateSelectors } from '@app/state/slices/listing-state.slice';
import { useAppSelector } from '@app/state/state';

export const SwitchStickyBar = ({
    availableOptions,
    switchProps = {},
    ...props
}: SwitchStickyBarProps) => {
    const { createReservationSwitch } = useSearchFilters({ availableOptions });
    const recipe = useSlotRecipe({ key: 'switchStickyBar' });
    const styles = recipe({});
    const realTimeItemCount = useAppSelector(listingStateSelectors.selectListingRealTimeItemCount);

    return (
        <StickyBar
            css={styles.wrapper}
            direction={StickyBarDirection['bottom']}
            bgColor={'transparent'}
            position={'fixed'}
            px={'gutterWidth'}
            boxShadow={'none'}
            {...props}
        >
            {createReservationSwitch(
                {
                    accommodationCount: realTimeItemCount,
                    variant: 'sticky',
                    w: 'full',
                    ...switchProps,
                },
                true,
            )}
        </StickyBar>
    );
};
